import { Typography } from "@mui/material";

import { PollOption } from "@infrastructure/Services/PostService.types";
import React, { ReactNode } from "react";
import {
    ImagePollOptionStack,
    PollImageDetailsStack,
    VotesPercentageTypography,
} from "../../PostPollOptions.styles";
import { Box } from "@mui/system";

export function PostPollImageOption({
    enableVoting,
    handlePollOptionClick,
    icon,
    isRespondedByCurrentUser,
    optionPercentage,
    pollOption,
    showSupportingText = true,
}: {
    enableVoting: boolean;
    handlePollOptionClick: (
        pollOptionId: number,
        type: "create" | "delete",
    ) => void;
    icon: ReactNode;
    isRespondedByCurrentUser: boolean;
    optionPercentage: number;
    pollOption: PollOption;
    showSupportingText: boolean;
}) {
    return (
        <ImagePollOptionStack
            onClick={() => {
                enableVoting &&
                    handlePollOptionClick(
                        pollOption.id,
                        isRespondedByCurrentUser ? "delete" : "create",
                    );
            }}
            direction={"row"}
            image={pollOption.content}
            pollIsActive={enableVoting}
        >
            <Box
                style={{
                    top: "8px",
                    left: "8px",
                    position: "absolute",
                }}
            >
                {icon}
            </Box>
            {isRespondedByCurrentUser && (
                <PollImageDetailsStack>
                    {optionPercentage > 0 && (
                        <>
                            <VotesPercentageTypography>
                                {optionPercentage}%
                            </VotesPercentageTypography>
                            {showSupportingText && (
                                <Typography
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        color: "var(--community-color-primary-color)",
                                        textAlign: "center",
                                    }}
                                >
                                    haben dies gewählt
                                </Typography>
                            )}
                        </>
                    )}
                </PollImageDetailsStack>
            )}
        </ImagePollOptionStack>
    );
}
